import React, { useEffect, useState } from 'react';
import { MdMailOutline } from "react-icons/md";
import { useUserContext } from '../context/UserContext';
import styled from '@emotion/styled';
import TextArea from '../pages/OrderEntry/ui/TextArea';
import TextField from '../pages/OrderEntry/ui/TextField';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const Wrapper = styled.div`
  position: fixed;
  bottom: 30px;
  right: 80px;
  cursor: pointer;
  z-index: 500;
`;

const OpenWrapper = styled.div`
  position: fixed;
  bottom: 30px;
  right: 80px;
  width: 500px;
  height: 500px;
  border-radius: 4px;
  padding: 40px;
  box-shadow: 0 8px 16px 0 rgba(190, 192, 199, 0.3);
  background-color: #fff;
  z-index: 500;
`;
const CancelButton = styled.button`
  background: #ffffff;
  border: 1px solid #e5e5ea;
  box-sizing: border-box;
  border-radius: 5px;
  color: #444444;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  width: 174px;
  height: 48px;
  cursor: pointer;
`;
const SubmitButton = styled.button`
  background: #444;
  border: 1px solid #444;
  box-sizing: border-box;
  border-radius: 5px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #ffffff;
  width: 144px;
  height: 46px;
  margin-left: 16px;
  cursor: pointer;
`;
export default function ContactUsPopup() {
  const [emailAddress, setEmailAddress] = useState('');
  const [emailNote, setEmailNote] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [success, setSuccess] = useState(false);
  const { user } = useUserContext();

  useEffect(() => {
    const path = window.location?.pathname;
    if (path) {
      const routeParts = path.split('/');
      const orderId = routeParts[routeParts.length - 1];
      if (!isNaN(+orderId)) {
        setOrderId(orderId);
      } else {
        setEmailNote(emailNote);
        setOrderId(null);
      }
    }
  }, [window.location.pathname]);
  useEffect(() => {
    if (user && formOpen) {
      setEmailAddress(user.email);
    }
  }, [user, formOpen]);
  const submitEmailMessage = async () => {
    const submitEmail = {
      orderId,
      userName: `${user.firstName} ${user.lastName}`,
      replyToEmail: emailAddress,
      emailNote,
      clientName: user.clientName,
      clientId: user.clientId
    };
    await axios.post('/api/clientAccount/submitClientMessage', submitEmail);
    setFormOpen(false);
    setEmailNote('');
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
    }, 3000);
  };
  return (
    <div >
      {formOpen ? (
        <OpenWrapper>
          <div style={{ fontSize: 18, lineHeight: 1.5 }}>
           Have a question{orderId ?  ' about this order'  : ''}? Send us a message and we will get back to you shortly.
          </div>
          <div style={{ marginTop: 30, marginBottom: 30 }}>
            <TextArea
              error=""
              label=""
              value={emailNote || ''}
              placeholder={'Enter your message here'}
              onChange={(e: any) => {
                setEmailNote(e.target.value);
              }}
              styles={{ width: 400, padding: 8,' :focus': { outline: 'none' }, caretColor: '#8e8e93' }}
            />{' '}
          </div>
          <TextField
            name="emailAddress"
            label="Reply to:"
            width="400px"
            value={emailAddress || ''}
            styles={{ input: { paddingLeft: 8 } }}
            onChange={(e: any) => setEmailAddress(e.target.value)}
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 50 }}>
            <CancelButton
              onClick={() => {
                setFormOpen(false);
                setEmailNote('');
              }}
            >
              Cancel
            </CancelButton>
            <SubmitButton onClick={submitEmailMessage}>Submit</SubmitButton>
          </div>
        </OpenWrapper>
      ) : (
        <Wrapper onClick={() => setFormOpen(!formOpen)}>
          <MdMailOutline size={70} />
        </Wrapper>
      )}
      {success && <div
              style={{
                position:'absolute',
                bottom: 130,
                right:50,
                padding: 24,
                backgroundColor: '#333',
                color: '#fff',
                borderRadius: 4,
              }}
            >
              Message Sent!
            </div>}
    </div>
  );
}
